export default __webpack_public_path__ + "static/mainBG-a0e4d8ffd6e727eeeceef33b4a40db90.jpg";